const common = {
  // Nav
  nav_home: "首页",
  nav_tracking: "追踪包裹",
  nav_admin: "管理后台",
  nav_brand: "Sonic Express Services",

  // Home
  home_hero_title: "追踪您的包裹",
  home_hero_subtitle: "全球实时物流追踪服务",
  home_search_placeholder: "输入追踪号码（例如 PT-2024-001）",
  home_search_btn: "立即追踪",
  home_features_title: "为什么选择我们？",
  home_feature1_title: "实时更新",
  home_feature1_desc: "在包裹旅程的每一步获取实时状态更新。",
  home_feature2_title: "全球覆盖",
  home_feature2_desc: "追踪全球200多个国家和地区的货物。",
  home_feature3_title: "即时提醒",
  home_feature3_desc: "当包裹状态发生变化时立即收到通知。",
  home_stats_parcels: "已追踪包裹",
  home_stats_countries: "覆盖国家",
  home_stats_satisfaction: "客户满意度",
  home_recent_title: "最近追踪",
  home_no_recent: "暂无追踪记录",
  home_track_another: "追踪其他包裹",

  // Parcel Details
  parcel_title: "包裹详情",
  parcel_tracking_number: "追踪号码",
  parcel_status: "状态",
  parcel_sender: "发件人",
  parcel_recipient: "收件人",
  parcel_weight: "重量",
  parcel_dimensions: "尺寸",
  parcel_origin: "发货地",
  parcel_destination: "目的地",
  parcel_current_location: "当前位置",
  parcel_estimated_delivery: "预计送达",
  parcel_timeline_title: "物流时间线",
  parcel_not_found: "未找到包裹",
  parcel_not_found_desc: "我们找不到该追踪号码对应的包裹，请检查后重试。",
  parcel_back_home: "返回首页",
  parcel_map_title: "当前位置",
  parcel_info_title: "货物信息",

  // Status labels
  status_processing: "处理中",
  status_in_transit: "运输中",
  status_out_for_delivery: "派送中",
  status_delivered: "已送达",
  status_exception: "异常",

  // Admin
  admin_title: "管理后台",
  admin_subtitle: "管理所有包裹及其追踪信息",
  admin_add_parcel: "添加新包裹",
  admin_search_placeholder: "按追踪号或收件人搜索...",
  admin_col_tracking: "追踪号",
  admin_col_recipient: "收件人",
  admin_col_status: "状态",
  admin_col_location: "当前位置",
  admin_col_updated: "最后更新",
  admin_col_actions: "操作",
  admin_edit: "编辑",
  admin_delete: "删除",
  admin_save: "保存更改",
  admin_cancel: "取消",
  admin_confirm_delete: "确定要删除此包裹吗？",
  admin_modal_add_title: "添加新包裹",
  admin_modal_edit_title: "编辑包裹",
  admin_field_tracking: "追踪号码",
  admin_field_status: "状态",
  admin_field_sender: "发件人",
  admin_field_recipient: "收件人",
  admin_field_weight: "重量",
  admin_field_dimensions: "尺寸",
  admin_field_origin: "发货地",
  admin_field_destination: "目的地",
  admin_field_location: "当前位置",
  admin_field_lat: "纬度",
  admin_field_lng: "经度",
  admin_field_estimated: "预计送达",
  admin_total_parcels: "包裹总数",
  admin_in_transit: "运输中",
  admin_delivered: "已送达",
  admin_processing: "处理中",
  admin_no_parcels: "未找到包裹",
  admin_password_label: "管理员密码",
  admin_password_placeholder: "请输入管理员密码",
  admin_login_btn: "登录",
  admin_login_title: "管理员登录",
  admin_login_error: "密码错误，请重试。",
  admin_logout: "退出登录",

  // Footer
  footer_desc: "您值得信赖的全球包裹追踪与物流解决方案合作伙伴。",
  footer_quick_links: "快速链接",
  footer_contact: "联系我们",
  footer_email: "sonicexpresservices@gmail.com",
  footer_rights: "版权所有。",
  footer_privacy: "隐私政策",
  footer_terms: "服务条款",

  // Missing keys
  parcel_phone: "手机号码",
  parcel_delivery_address: "送货地址",

  // Tracking page hardcoded strings
  tracking_number_label: "追踪号码",
  tracking_live_active: "实时追踪中",
  tracking_delivery_details: "收件详情",
  tracking_shipment_info: "货物信息",
  tracking_looking_up: "正在查询您的包裹...",
  tracking_checking: "正在核查追踪号码",
  tracking_invalid_format: "追踪号码格式无效",
  tracking_invalid_desc: "该追踪号码格式不正确。",
  tracking_invalid_format_hint: "Sonic Express 追踪号码格式为：",
  tracking_invalid_copy_hint: "请确保您完整复制了追踪号码，包括 SE- 前缀。",
  tracking_try_again: "重新尝试",
  tracking_not_registered: "包裹未登记",
  tracking_not_registered_desc: "该追踪号码在我们系统中未登记或不存在。",
  tracking_not_registered_hint: "请仔细核对您的追踪号码，或联系发件人确认货物是否已登记。",

  // Shipment progress stage labels
  stage_processing: "处理中",
  stage_in_transit: "运输中",
  stage_out_for_delivery: "派送中",
  stage_delivered: "已送达",
  progress_current_location: "当前位置",
  progress_action_required: "可能需要您的操作",
  progress_exception_desc: "您的包裹可能正在进行海关清关或需要补充文件。我们的团队正在跟进处理，请联系客服获取最新进展。",
  progress_complete: "已完成",

  // Timeline
  timeline_origin: "起始地",
  timeline_destination: "目的地",
  timeline_live: "实时",

  // Language
  lang_en: "English",
  lang_zh: "中文",
  lang_th: "ภาษาไทย",
};

export default common;
